import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/context/LanguageContext';
import { Globe, Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { key: 'features', label: 'Funciones' },
  { key: 'couple', label: 'Pareja' },
  { key: 'how-it-works', label: 'Cómo funciona' },
  { key: 'pricing', label: 'Precios' },
  { key: 'faq', label: 'FAQ' },
];

export default function LandingNav2({ onCta }) {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleLang = () => setLanguage(language === 'es' ? 'en' : 'es');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'glass border-b border-gray-200/50 dark:border-gray-800/50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-500 to-accent-500 flex items-center justify-center text-white font-bold text-sm">
            K2
          </div>
          <span className="font-display font-bold text-lg text-gray-900 dark:text-white">
            Kuadra2
          </span>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          {NAV_LINKS.map((link) => (
            <button
              key={link.key}
              onClick={() => scrollToSection(link.key)}
              className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* Right side actions */}
        <div className="flex items-center gap-3">
          <button
            onClick={toggleLang}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            <Globe size={16} />
            {language === 'es' ? 'EN' : 'ES'}
          </button>
          <button
            onClick={onCta}
            className="hidden sm:block btn-primary text-sm py-2 px-5"
          >
            {t('landing.hero.cta')}
          </button>
          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X size={20} className="text-gray-600 dark:text-gray-300" />
            ) : (
              <Menu size={20} className="text-gray-600 dark:text-gray-300" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden glass border-b border-gray-200/50 dark:border-gray-800/50">
          <div className="px-4 py-4 space-y-2">
            {NAV_LINKS.map((link) => (
              <button
                key={link.key}
                onClick={() => scrollToSection(link.key)}
                className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={onCta}
              className="w-full btn-primary text-sm py-3 mt-2"
            >
              {t('landing.hero.cta')}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
